function createDataUriString(json: string) {
  return "data:text/json;charset=utf-8," + encodeURIComponent(json);
}

export default createDataUriString;
